export default "__VITE_ASSET__3zUd9SRh__"